import * as Yup from 'yup';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { PlateformeFormFieldNames } from '../form/PlateformeFormFieldNames';

/**
 * Validation de l'édition identité + coordonnées de la corporate. Aligné sur la
 * création, MAIS l'adresse n'exige PAS le google_place_id (l'entité ne le stocke
 * pas — forcer une re-sélection à chaque édition serait pénible).
 */
export const corporateInfoValidationSchema = Yup.object({
  [PlateformeFormFieldNames.Name]: Yup.string()
    .required('Le nom est requis')
    .min(2, 'Le nom doit contenir au moins 2 caractères'),
  [PlateformeFormFieldNames.Code]: Yup.string()
    .required('Le code entreprise est requis')
    .when(PlateformeFormFieldNames.ConnectionMode, {
      is: 'SSO_PARTENAIRE',
      then: (schema) => schema.trim().required('Un code entreprise est requis pour le mode SSO partenaire'),
    }),
  [PlateformeFormFieldNames.ConnectionMode]: Yup.string()
    .required('Le mode de connexion est requis')
    .oneOf(['STANDARD', 'SSO_PARTENAIRE']),
  [PlateformeFormFieldNames.RegistrationNumber]: Yup.string()
    .required('Le numéro SIREN est requis')
    .matches(/^\d{9}$/, 'Le SIREN doit contenir 9 chiffres'),
  [PlateformeFormFieldNames.Capital]: Yup.number()
    .required('Le capital est requis')
    .min(0, 'Le capital doit être positif'),
  [PlateformeFormFieldNames.RcsCity]: Yup.string().required('La ville RCS est requise'),
  [PlateformeFormFieldNames.RcsNumber]: Yup.string().required('Le numéro RCS est requis'),
  // Une corporate n'est pas un intermédiaire immatriculé : ORIAS optionnel.
  [PlateformeFormFieldNames.OriasNumber]: Yup.string().nullable().notRequired(),
  [PlateformeFormFieldNames.Rcp]: Yup.string().nullable().notRequired(),
  [PlateformeFormFieldNames.Phone]: Yup.string()
    .required('Le téléphone est requis')
    .matches(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/, 'Format de téléphone invalide'),
  [PlateformeFormFieldNames.Email]: Yup.string()
    .required("L'email est requis")
    .email('Format email invalide'),
  [AddressFormFieldNames.Address]: Yup.string()
    .trim()
    .required("L'adresse est requise")
    .min(2, "L'adresse doit contenir au moins 2 caractères"),
  [AddressFormFieldNames.AdditionalAddress]: Yup.string().trim().nullable(),
  [AddressFormFieldNames.PostalCode]: Yup.string()
    .trim()
    .required('Le code postal est requis')
    .matches(/^\d{4,6}$/, 'Le code postal doit contenir entre 4 et 6 chiffres'),
  [AddressFormFieldNames.City]: Yup.string().trim().required('La ville est requise'),
  [AddressFormFieldNames.Country]: Yup.string()
    .trim()
    .required('Le pays est requis')
    .matches(/^[A-Z]{2}$/, 'Le pays doit être un code ISO à 2 lettres'),
});
